<template>
  <div id="registration-form">
    <div class="tabs is-centered">
      <ul>
        <li :class="{ 'is-active': activeSection === KindSection.Personal }">
          <a @click="activeSection = KindSection.Personal">
            <span class="icon is-small">
              <i class="far fa-user" aria-hidden="true"></i>
            </span>
            <span>Personal Information</span>
          </a>
        </li>
        <li :class="{ 'is-active': activeSection === KindSection.Health }">
          <a @click="activeSection = KindSection.Health">
            <span class="icon is-small">
              <i class="far fa-file-alt" aria-hidden="true"></i>
            </span>
            <span>Antecedentes de salud</span>
          </a>
        </li>
      </ul>
    </div>
    <div
      class="registration-container px-5"
      v-show="activeSection === KindSection.Health"
    >
      <Suspense>
        <template #default>
          <health-form v-model="patient.healthBackground"></health-form>
        </template>
        <template #fallback>
          <div><inline-loading-indicator></inline-loading-indicator></div>
        </template>
      </Suspense>
    </div>
    <div
      class="registration-container px-5"
      v-show="activeSection === KindSection.Personal"
    >
      <div class="field">
        <label class="label">Apellidos</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.lastName"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Nombres</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.firstName"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">N&uacute;mero de DNI</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.dni"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">N&uacute;mero de celular</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.phoneNumber"
          />
        </div>
      </div>

      <div class="field">
        <select-form
          label="Sexo"
          :items="['Masculino', 'Femenino']"
          v-model="patient.genre"
        />
      </div>

      <div class="field">
        <label class="label">Fecha de Nacimiento</label>
        <div class="control">
          <input
            class="input"
            type="date"
            v-model="patient.birthDate"
            placeholder="Fecha de Nacimiento"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Nombre de contacto en caso de emergencia</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.emergencyContact.name"
          />
        </div>
      </div>

      <div class="field">
        <label class="label"
          >N&uacute;mero de contacto en caso de emergencia</label
        >
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.emergencyContact.phoneNumber"
          />
        </div>
      </div>

      <div class="control">
        <label class="label">¿D&oacute;nde vive usted?</label>
        <div class="control">
          <Suspense>
            <template #default>
              <location-form-input
                v-model="patient.address"
              ></location-form-input>
            </template>
            <template #fallback>
              <div><inline-loading-indicator></inline-loading-indicator></div>
            </template>
          </Suspense>
        </div>
      </div>

      <div class="field">
        <label class="label">Grado de instrucci&oacute;n</label>
        <div class="control">
          <select-form
            :items="educationLevels"
            v-model="patient.educationLevel"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Ocupaci&oacute;n</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            v-model="patient.ocupation"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Modalidad de trabajo</label>
        <div class="control has-text-left">
          <div class="select">
            <select v-model="patient.workScheme">
              <option>teletrabajo</option>
              <option>presencial</option>
              <option>mixto</option>
            </select>
          </div>
        </div>
      </div>
      <div class="pb-4">
        <button class="button is-bg-primary is-fullwidth" @click="onSave">
          Registrarse
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  // onMounted,`
  ref,
  inject,
} from "vue";
import { Patient, educationLevels } from "@/domain/entities/Patient";
import { PatientRepository } from "@/infraestructure/patient/PatientRepository";
import { pprint } from "@/helpers/pprint";
import SelectForm from "./SelectForm.vue";
import LocationFormInput from "./LocationFormInput.vue";
import HealthForm from "./HealthForm.vue";
import useNotification from "@/store/NotificationState";
import useUser from "@/store/UserState";

enum KindSection {
  Personal,
  Health,
}

export default defineComponent({
  name: "patient-form",
  components: {
    HealthForm,
    LocationFormInput,
    SelectForm,
  },
  async setup() {
    const {user} = useUser()

    let activeSection = ref(KindSection.Personal);
    // init
    let patientRespository = inject(
      PatientRepository.key
    ) as PatientRepository;

    const { showSnackbar } = useNotification();
    async function onSave() {
      pprint(user.value);
      let err = Patient.validateNonEmptyRegistrationFields(user.value as Patient);
      pprint("err", err?.[0]);
      if (err !== undefined) {
        showSnackbar(`Campo vacío ${err[0]}`);
        return;
      }
      const patientData = user.value as Patient
      patientData.hasFilledPersonalInformation = true
      await patientRespository.updatedData(patientData);
			(user.value as Patient).hasFilledPersonalInformation = true
    }

    return {
      activeSection,
      KindSection,
      onSave,
      patient: user,
      educationLevels,
    };
  },
});
</script>

<style lang="stylus" scoped>
#registration-form {
  text-align: center;
}

.registration-container {
  max-width: 400px;
  margin: 0 auto;
}

.label {
  text-align: left;
}
</style>

